<template>
	<vue-json-pretty
		:data="data"
		:deep="open ? Number.Infinity : 0"
		:showLength="true"
	>
	</vue-json-pretty>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'

export default {
	props: {
		data: Object,
		open: Boolean,
	},
	components: {
		VueJsonPretty,
	},
}
</script>
